import PropTypes from "prop-types";

const ExternalLink = ({ to, className, text, children }) => {
    return (
        <a href={to} target="_blank" rel="noopener noreferrer" className={className}>
            {text ? text : children}
        </a>
    );
};

ExternalLink.propTypes = {
    to: PropTypes.string.isRequired,
    className: PropTypes.string,
    text: PropTypes.string,
    children: PropTypes.element
};

export default ExternalLink;
